/**
 * Плагин работы с консолью
 */

const debug = {
    /**
     * Выводит сообщение в консоль
     *
     * @param {string || array} message Выводимая информация
     */
    log: (message) => {
        if (process.env.NODE_ENV == "development") {
            console.groupCollapsed(Array.isArray(message) ? "Array" : message);
            console.log(`${ new Date().toLocaleDateString() } ${ new Date().toLocaleTimeString() }: `, message);
            //console.log(message);
            console.trace();
            console.groupEnd();
        }
    },

    /**
     * Выводит сообщеник со стеком вызовов
     *
     * @param {string || array} message Выводимая информация
     */
    trace: (message) => {
        if (process.env.NODE_ENV == "development") {
            //console.log(`${ new Date().toLocaleDateString() } ${ new Date().toLocaleTimeString() }: ${message}`);

            if (Array.isArray(message)) {
                message.forEach(item => console.trace(item));
            } else {
                console.trace(message);
            }
        }
    },

    /**
     * Выводит сообщеник об ошибке в консоль
     *
     * @param {string || array} message Выводимая информация
     */
     error: (message) => {
        if (process.env.NODE_ENV == "development") {
            let title;

            if (Array.isArray(message)) {
                title = "Array";
                message.forEach(item => console.error(item));
            } else {
                title = message;
                console.error(message);
            }

            console.groupCollapsed(`${title}: Trace`);
            console.log(`${ new Date().toLocaleDateString() } ${ new Date().toLocaleTimeString() }: `, message);
            console.trace();
            console.groupEnd();
        }
    },

    /**
     * Выводит табличные данные в консоль
     *
     * @param {array}   data  Выводимая информация
     * @param {boolean} trace Флаг вывода стека вызовов
     */
     table: (data, trace = false) => {
        if (process.env.NODE_ENV == "development") {
            //console.info(`${ new Date().toLocaleDateString() } ${ new Date().toLocaleTimeString() }: ${message}`);
            console.table(data);

            if (trace) {
                console.groupCollapsed("Trace");
                console.log(`${ new Date().toLocaleDateString() } ${ new Date().toLocaleTimeString() }: `, message);
                console.trace();
                console.groupEnd();
            }
        }
    },

    /**
     * Выводит предупреждение в консоль
     *
     * @param {string || array} message Выводимая информация
     */
     warn: (message) => {
        if (process.env.NODE_ENV == "development") {
            let title;

            if (Array.isArray(message)) {
                title = "Array";
                message.forEach(item => console.warn(item));
            } else {
                title = message;
                console.warn(message);
            }

            console.groupCollapsed(`${title}: Trace`);
            console.log(`${ new Date().toLocaleDateString() } ${ new Date().toLocaleTimeString() }: `, message);
            console.trace();
            console.groupEnd();
        }
    },
}

export default debug;
